export const engagementAppGroupIdFromEmailDomains = "/engagement/:app_group_id/from_email_domains";
